module.exports = __webpack_public_path__ + "static/media/ps.a4335f8c.svg";